import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Icon from 'foundations/Icons/Icon';

import styles from './DraggableTag.css';

const DraggableTag = props => {
  const {
    preDefined,
    customStyles,
    name,
    isDragging,
    isDraggingOver
  } = props;
  const generalClasses = classnames('tag');
  const cx = classnames.bind(styles);
  const classes = cx(
    'tag',
    {
      preDefined,
      isDragging,
      isDraggingOver
    }
  );

  return (
    <span
      className={`${generalClasses} ${classes}`}
      style={customStyles}
    >
      <Icon icon={'drag-grip'} type={'15'}/>
      {name}
    </span>
  );
};

DraggableTag.propTypes = {
  name: PropTypes.string.isRequired,
  customStyles: PropTypes.object,
  preDefined: PropTypes.bool,
  isDragging: PropTypes.bool,
  isDraggingOver: PropTypes.bool
};

export default DraggableTag;



// WEBPACK FOOTER //
// ./src/uis/elements/Tags/DraggableTags/DraggableTag/DraggableTag.js